import { FilterableField } from 'module/types/filter-field/field/filterable-field';
import { NoValue } from 'module/ui/components/atoms/no-value/empty-cell';
import { RichTextEditorInput } from 'module/ui/components/atoms/rich-text-editor-input/editor';
import { ICellRendererParams } from 'ag-grid-community';
import { isString } from 'lodash';
import { FC } from 'react';
import styled from 'styled-components';

const NoteWrapper = styled.div`
  width: 100%;
  cursor: pointer;
  height: inherit;
  display: flex;
  align-items: center;
  --rte-min-height: 0;
  --rte-content-padding: var(--spacing-02) var(--spacing-03) var(--spacing-03) 0;
  --rte-background: transparent;
  .ck.ck-content.ck-editor__editable.ck-editor__editable_inline {
    max-height: var(--height-lg);
    white-space: pre-wrap;
    line-height: var(--spacing-07);
    overflow: hidden;
  }
  .ck.ck-content.ck-editor__editable.ck-editor__editable_inline.ck-read-only {
    padding: var(--rte-content-padding);
  }
`;

export const NoteFieldRenderer: FC<
  React.PropsWithChildren<
    ICellRendererParams & {
      field: FilterableField;
      openNote?: (field: FilterableField, data) => void;
    }
  >
> = ({ openNote, field, data, value }) => {
  return (
    <NoteWrapper onClick={() => openNote?.(field, data)}>
      {value == null || !isString(value) ? (
        <NoValue />
      ) : (
        <RichTextEditorInput value={value?.replaceAll('\n', '<br>')} readonly />
      )}
    </NoteWrapper>
  );
};
